import { useRequiredContext } from "@redotech/react-util/context";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";

import { createContext, memo } from "react";

export interface SupportSuiteStatuses {
  supportEnabled: boolean;
}

export const SupportSuiteStatusesContext = createContext<
  SupportSuiteStatuses | undefined
>(undefined);

export const SupportSuiteStatusesProvider = memo(
  function SupportSuiteStatusesProvider({
    children,
  }: {
    children: React.ReactNode;
  }) {
    const team = useRequiredContext(TeamContext);
    const settings = team.settings;

    const supportEnabled = !!settings.support?.enabled;

    const supportSuiteStatuses = { supportEnabled };

    return (
      <SupportSuiteStatusesContext.Provider value={supportSuiteStatuses}>
        {children}
      </SupportSuiteStatusesContext.Provider>
    );
  },
);

export { default as SUPPORT_ICON } from "@redotech/redo-icons/message-text-square-02.svg";
export { default as SUPPORT_ICON_FILLED } from "@redotech/redo-icons/message-text-square-02_filled.svg";
